var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisualStudioCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.85,
    height: 40.413,
    viewBox: "0 0 40.85 40.413",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visual-studio-code",
    transform: "translate(-2.725 -13.962)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M3.114,248.268s-.995-.717.2-1.675l2.782-2.487A1.181,1.181,0,0,1,7.732,244L33.4,263.432v9.319s-.012,1.463-1.89,1.3Z",
    transform: "translate(0 -220.214)",
    fill: "#2489ca"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M11.73,498.8l-6.616,6.015s-.68.506,0,1.41l3.072,2.794a1.262,1.262,0,0,0,1.807-.108l7.014-5.319Z",
    transform: "translate(-2 -464.739)",
    fill: "#1070b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M305.339,41.983l12.134-9.265-.079-9.27s-.518-2.023-2.247-.97L299,37.174Z",
    transform: "translate(-283.992 -7.872)",
    fill: "#0877b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M688.856,53.852a1.669,1.669,0,0,0,1.559.485l9.456-4.66a1.994,1.994,0,0,0,1.041-1.849V20a1.86,1.86,0,0,0-1.252-1.646l-8.2-3.951a2.276,2.276,0,0,0-2.964.2s1.509-1.086,2.247.97V52.368a1.672,1.672,0,0,1-.162.725c-.216.435-.684.842-1.807.672Z",
    transform: "translate(-657.345 0)",
    fill: "#3c99d4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisualStudioCode);
export default __webpack_public_path__ + "static/media/visual-studio-code.1abf949973fa3b3f1eaa2fde5697f053.svg";
export { ForwardRef as ReactComponent };